import { createFileRoute } from '@tanstack/react-router';

import { EmployeeDashboardHome, EmployeeDashboardProvider } from '../modules/EmployeeDashboard';
import { PageWrapper } from '../modules/PageWrapper/main';

export const Route = createFileRoute('/dashboard-home')({
  component: DashboardHomePreviewRoute,
  head: () => ({
    meta: [{ title: 'Dashboard' }],
  }),
});

function DashboardHomePreviewRoute() {
  return (
    <PageWrapper>
      <EmployeeDashboardProvider>
        <EmployeeDashboardHome />
      </EmployeeDashboardProvider>
    </PageWrapper>
  );
}
